export const dtUtilsMixin = {
  methods: {
    currentYear () {
      return new Date().getFullYear()
    },
    today () {
      return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
    },
    formatDateDMY (date, separator1, separator2) {
      if (!date) return null
      const [year, month, day] = date.split(separator1)
      return `${day}${separator2}${month}${separator2}${year}`
    },
    formatDateYMD (date, separator1, separator2) {
      if (!date) return null
      const [year, month, day] = date.split(separator1)
      return `${year}${separator2}${month}${separator2}${day}`
    },
    extractDatePart (date, separator = 'T', part = 0) {
      try {
        return new Date(date).toISOString().split(separator)[part]
      } catch (err) {
        return null
      }
    },
    confDate (s, locale = 'ru-RU') {
      return new Date(s).toLocaleString(locale)
    }
  }
}
